const initialState = {
  data: [],
  activeCategoryUID: null,
  total: 0,
}

const DataTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_CATEGORIES':
      return {
        ...state,
        data: action.payload.categories,
        total: action.payload.categories.length,
        activeCategoryUID: action.payload.activeCategoryUID || state.activeCategoryUID,
      }
    case 'SET_ACTIVE_CATEGORY':
      return {
        ...state,
        activeCategoryUID: action.payload.activeCategoryUID,
      }
    default:
      return state
  }
}

export default DataTablesReducer
